import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl,mediaUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';

import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';


class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
		this.editorRef = React.createRef();
	    const cateId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		this.state = {
            cateId: cateId,
			title:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedTitle:{ value: '', label: 'Select Category'},
			selectedvalue:'',
			description:'',
			image_preview:'',
			image_name:'',
			image:'',
			images:'',
			selectedLinktoOption:{ value: '', label: 'Please select a link'},
			selectedLinkToOption: null,
	         selectedLinkToValue: '',
		};
		// this.props.getCategoryDetailList(cateId);

		var qs = require('qs');
			var postObject ={
					admin_id: localStorage.getItem('admin_id'),
		
			}
		// 	 axios.post(apiUrl+"Promtdropdown/dropdownoptions",qs.stringify(postObject)).then(res => {
			  
		// 	  if(res.data.status === 'success'){
		// 		  this.setState({ linkToOptions: res.data.categorylist});
		// 	  }
		// 	});
		var qs = require('qs');
		 var catid = this.state.cateId;

		// axios.get(apiUrl+"Promtdropdown/listdetail?id="+catid).then(res => {

		// 	const editorInstance = this.editorRef.current?.getInstance();
		// 	if (editorInstance &&res.data.categorylist.description !=null &&res.data.categorylist.description!='') {
		// 	  editorInstance.setHTML(res.data.categorylist.description);
		// 	}
		// 	this.setState({title:res.data.categorylist.name,priorty:res.data.categorylist.priority,});
		// 	if(res.data.categorylist.status === 'A'){
		// 		this.setState({selectedOption:{value: 'active', label: 'Active'}});
		// 	}else{
		// 	this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
		// 	}

		// }); 	
		Promise.all([
    axios.post(apiUrl+"Promtdropdown/dropdownoptions", qs.stringify(postObject)),
    axios.get(apiUrl+"Promtdropdown/listdetail?id=" + catid)
]).then(([optRes, detailRes]) => {
    
    const options = optRes.data.categorylist;
    const detail = detailRes.data.categorylist;

    // Save dropdown options
    this.setState({ linkToOptions: options });

    // Prefill values
    const selectedOption = options.find(
        opt => opt.value == detail.link_to
    );

    this.setState({
        title: detail.name,
        priorty: detail.priority,
        selectedLinkToOption: selectedOption,
        selectedLinkToValue: detail.link_to,
        selectedOption:
            detail.status === "A"
            ? { value: "active", label: "Active" }
            : { value: "inactive", label: "Inactive" }
    });

});


		 
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
		this.onEditorChangetext = this.onEditorChangetext.bind(this);
    }

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}
		if(r=='title')
		{
			this.setState({  title : selOption.value});
		}
			if (r == 'linkTo') {
				this.setState({
					selectedLinkToOption: selOption,
					selectedLinkToValue: selOption.value
				});
		}
 	};
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
     		
    }
	onEditorChangetext = () => {
		// Directly get HTML from editor (auto includes <p>, <br>)
		const html = this.editorRef.current.getInstance().getHTML();
		this.setState({description: html});	
		// onSave(html); // Save directly to DB
	};
	componentDidMount() {
		document.title = PageTitle('Promtdropdown Edit');

		
    }
	
        handleFormSubmit = () => {
			if(this.validateForm()){ 
				this.setState({Loading:true});
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				var link_to = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
					status =formPayload.selectedOption.value;
				}else{
					status = formPayload.selectedvalue;
				}

				if(formPayload.selectedLinkToValue === ''){
					link_to = formPayload.selectedLinkToOption.value;
				}else{
					link_to = formPayload.selectedLinkToValue;
				}

				
				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					title: formPayload.title,
					priorty : formPayload.priorty,
					status:  status,
					link_to:  link_to,
					
					
					id: formPayload.cateId				
				};		
				let formData = new FormData();
				for (let k in postObject) {
					formData.append(k, postObject[k]);
				}
				
				axios.post(apiUrl+"Promtdropdown/edit",formData ).then(res => {
					if(res.data.status === "success"){	
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
							setTimeout(
							function() {
								$('.success_message').html(this.props.history.push('/promtdropdownList'));
							}
							.bind(this),
							3000
							);
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
						this.setState({Loading:false});
					}
				});
			}
	}

	validateForm() {
		const {title} = this.state;
	
		let errors = {};
		  let formIsValid = true;
	
		  if(!title){
			formIsValid = false;
			$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
		}else{
			
			$('.errortitle').html('');
		}
			
		this.setState({
			errors: errors
		});
		return formIsValid;
	}
	
	onChangeHandler = (event) => {
		const files = Array.from(event.target.files);
		const previews = [];
	  
		files.forEach((file) => {
		  const reader = new FileReader();
		  reader.onloadend = () => {
			previews.push({ name: file.name, data: reader.result });
	  
			// Once all previews are read, update state
			if (previews.length === files.length) {
			  this.setState({
				images: files,
				image_previews: previews,
			  });
			}
		  };
		  reader.readAsDataURL(file);
		});
	  };
	  removeImage = (index) => {
		const newImages = [...this.state.images];
		const newPreviews = [...this.state.image_previews];
	  
		newImages.splice(index, 1);
		newPreviews.splice(index, 1);
	  
		this.setState({
		  images: newImages,
		  image_previews: newPreviews
		});
	  }; 

  render() {
	// console.log(this.state,'render');
  	const {selectedOption,selectedTitle ,selectedLinktoOption,linkToOptions,selectedLinkToOption} = this.state;	
	const loaderimg = mediaUrl+'/insurance/'+this.state.image_name;
	var preview = <img className="img_class" src={loaderimg} alt="" />;
		

    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="promtdropdownList" />  
      <div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/promtdropdownList">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Promt Dropdown Details</h4>
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Name<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title} />

					

					<div className="errortitle"></div>
				</div>	

					
		

					<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select 
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option} 
                            onChange={this.handleChange.bind(this, 'status')}
                            />
	           </div> 	
			</div>
                  
			<div className="form-right">

				<div className="form-group">
					<label>Priority<span class="required" style={{ color: "red" }} > * </span>: </label>
					<input type="text" name="priorty" className="form-control" value={this.state.priorty}  onChange={this.handleInputChange} autoComplete="off" />
					<div className="error_priorty"></div>
				</div>

				

			   <div className="form-group">					
						<label>Link To :</label>
						<Select 
							name="linkTo"
							value={selectedLinkToOption || { value: '', label: 'Please select a link' }}
							options={linkToOptions} 
							isSearchable={false}
							onChange={this.handleChange.bind(this, 'linkTo')}
						/>
					</div>
				
				

			</div>	
			</div>		



			<div className="btn-group export">	
				  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>updating</span>:<span>Submit</span>
                                        }
                   </button>
			</div>
			</form>
			</div>				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Edit));